export default "__VITE_ASSET__DjLYsfyt__"